export const getTwitchAuthURL = () => {
  const baseURL = "https://id.twitch.tv/oauth2/authorize";
  const clientID = "losvlc63e0x5gpcjbjcfwpweyg8i2v";

  const domain = window.location.host.includes("localhost")
    ? `http://${window.location.host}`
    : `https://${window.location.hostname}`;

  const customState = JSON.stringify({
    csrf: "c3ab8aa609ea11e793ae92361f002671", // optional: for validation
    redirect: `${domain}/twitch-auth`, // your real return target
  });

  const body = new URLSearchParams({
    response_type: "code",
    client_id: clientID,
    redirect_uri:
      "https://europe-west1-spike-ba886.cloudfunctions.net/twitchAuth",
    state: btoa(customState), // base64 encode the JSON
    grant_type: "authorization_code",
    scope: "user:read:email",
  });

  return `${baseURL}?${body.toString()}`;
};
